// SSR-safe Strapi data fetcher
export const fetchStrapiDataSSR = async (params, options = {}) => {
  const isSSR = typeof window === 'undefined';
  
  if (isSSR) {
    const serverPort = options.serverPort || 4000;
    const internalApiBaseUrl = process.env.SSR_INTERNAL_API_BASE_URL;
    
    // During SSR this request is made by the Node server itself. Using the
    // public canonical URL can route the POST through CloudFront/WAF and block
    // SEO page data loading, which leaves pages with an empty JSON-LD schema.
    const serverUrl = internalApiBaseUrl
      ? `${internalApiBaseUrl.replace(/\/$/, '')}/api/strapi`
      : `http://127.0.0.1:${serverPort}/api/strapi`;
    
    const response = await fetch(serverUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`SSR Strapi API error: ${response.status} - ${errorText}`);
    }

    return await response.json();
    
  } else {
    const { fetchStrapiData } = await import('./api');
    return fetchStrapiData(params);
  }
};
